import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID,

    IInstitutionItemsLoadByInstitutionIdAction,
    IInstitutionItemLoadFailureAction,
    IInstitutionItemLoadSuccessAction,

    LoadSuccess,
    LoadFailure,
    IInstitutionItemCreateSuccessAction,
    IInstitutionItemCreateFailureAction,
    IInstitutionItemCreateAction,
    IInstitutionItemSaveSuccessAction,
    IInstitutionItemSaveFailureAction,
    ACTION_INSTITUTIONITEM_SAVE,
    IInstitutionItemSaveAction,
    SaveFailure,
    SaveSuccess,
    ACTION_INSTITUTIONITEM_CREATE,
    CreateSuccess,
    CreateFailure,
    ACTION_INSTITUTIONITEM_LOAD_BY_ID,
    IInstitutionItemLoadByIdAction,

} from "../actions/institutionItem";
import { institutionItemApi } from "../services/institutionItems";


export const
    getInstitutionItemByIdEpic = (action$): Observable<IInstitutionItemLoadSuccessAction | IInstitutionItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEM_LOAD_BY_ID)
            .mergeMap((action: IInstitutionItemLoadByIdAction) => {
                return institutionItemApi
                    .getInstitutionItemById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionItem, undefined, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionItemsByInstitutionIdEpic = (action$): Observable<IInstitutionItemLoadSuccessAction | IInstitutionItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID)
            .mergeMap((action: IInstitutionItemsLoadByInstitutionIdAction) => {
                return institutionItemApi
                    .getInstitutionItemsByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionItems, response.institutionItemCategories, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionItemEpic = (action$): Observable<IInstitutionItemSaveSuccessAction | IInstitutionItemSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEM_SAVE)
            .mergeMap((action: IInstitutionItemSaveAction) => {
                return institutionItemApi
                    .setInstitutionItem(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionItem, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionItemEpic = (action$): Observable<IInstitutionItemCreateSuccessAction | IInstitutionItemCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEM_CREATE)
            .mergeMap((action: IInstitutionItemCreateAction) => {
                return institutionItemApi
                    .createInstitutionItem(action.institutionId)
                    .map(response =>
                        CreateSuccess(response.institutionItem, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }